import Swiper, { Autoplay, Navigation } from "swiper";

new Swiper(".swiper-testimonial-item", {
    loop: false,
    speed: 3000,
    preloadImages: false,
    modules: [Autoplay, Navigation],
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    navigation: {
        prevEl: ".swiper-testimonial-item-prev",
        nextEl: ".swiper-testimonial-item-next",
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 15,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
});

new Swiper(".swiper-why-yesrentals-learn-more-item", {
    loop: false,
    speed: 3000,
    preloadImages: false,
    modules: [Autoplay],
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 15,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
});

new Swiper(".swiper-partners-item", {
    loop: false,
    speed: 3000,
    preloadImages: false,
    modules: [Autoplay, Navigation],
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    navigation: {
        prevEl: ".swiper-partners-item-prev",
        nextEl: ".swiper-partners-item-next",
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 15,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
});

new Swiper(".swiper-vehicles", {
    loop: false,
    speed: 3000,
    preloadImages: false,
    modules: [Autoplay, Navigation],
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    navigation: {
        prevEl: ".swiper-vehicles-prev",
        nextEl: ".swiper-vehicles-next",
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 15,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
});

function openLiveChat() {
    zE("messenger", "open");
}
